import { render, staticRenderFns } from "./ReleasesAdminList.vue?vue&type=template&id=560d632e&"
import script from "./ReleasesAdminList.vue?vue&type=script&lang=js&"
export * from "./ReleasesAdminList.vue?vue&type=script&lang=js&"
import style0 from "./ReleasesAdminList.vue?vue&type=style&index=0&id=560d632e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports